import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, QueryList, SecurityContext, ViewChild, ViewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { throttleTime } from 'rxjs/operators';
import { THEME } from 'src/app/constants/ui-theme.constants';
import { DeviceService } from 'src/app/services/device/device.service';
import { BaseComponent } from '../../base/base.component';
import { ModalRebootConfirmComponent } from '../../modal/modal-reboot-confirm/modal-reboot-confirm.component';
import { ModalVoiceComponent } from '../../modal/modal-voice/modal-voice.component';

@Component({
	selector: 'vtr-ui-row-switch',
	templateUrl: './ui-row-switch.component.html',
	styleUrls: ['./ui-row-switch.component.scss'],
	exportAs: 'uiRowSwitch'
})
export class UiRowSwitchComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('childContent', { static: false }) childContent: any;

	// Use Fort Awesome Font Awesome Icon Reference Array (library, icon class) ['fas', 'arrow-right']
	@Input() rightIcon: any = [];
	@Input() leftIcon: any = [];
	@Input() showChildContent = false;
	@Input() readMoreText = '';
	@Input() title = '';
	@Input() caption = '';
	@Input() linkPath = '';
	@Input() linkText = '';
	@Input() isSwitchVisible = false;
	@Input() theme = THEME.DARK;
	@Input() resetText = '';
	@Input() isSwitchChecked = true;
	@Input() tooltipText = '';
	@Input() switchId = '';
	@Input() disabled = false;
	@Input() disabledAll = false;
	@Input() type = undefined;
	@Input() resetTextAsButton = false;
	@Input() isLastChild = false;
	@Input() showLoaderState = false;
	@Input() voice = false;
	@Input() voiceValue = '';
	@Output() toggleOnOff = new EventEmitter<boolean>();
	@Output() rebootToggleOnOff = new EventEmitter<boolean>();
	@Output() readMoreClick = new EventEmitter<boolean>();
	@Output() tooltipClick = new EventEmitter<boolean>();
	@Output() resetClick = new EventEmitter<Event>();
	@Output() customButtonClick = new EventEmitter<Event>();
	@Input() toolTipStatus = false;
	@Input() isDisabled = false;
	@Input() metricsParent = '';
	@Input() isAdminRequired = false;
	@Input() isRebootRequired = false;
	@Input() label = '';
	@Input() fnCtrltoolTip = false;
	@Input() tooltipContent = [];
	@Input() headingLevel: number;
	@Input() showCustomButton = false;
	@Input() customButtonText = '';

	public contentExpand = false;
	@Input() isMetricsEnabled = false;
	@ViewChild('rightToolTip1', { static: false }) rightToolTip1: ElementRef;
	@ViewChild('rightToolTip2', { static: false }) rightToolTip2: ElementRef;
	@ViewChild('rightToolTip3', { static: false }) rightToolTip3: ElementRef;
	@ViewChild('captionRef', { static: false }) captionRef: ElementRef;
	@ViewChildren(NgbTooltip) toolTips: QueryList<NgbTooltip>;
	scrollEvent = new Subject();

	subscriptionList = [];

	WHITE_THEME = THEME.WHITE;
	DARK_THEME = THEME.DARK;
	BLUE_THEME = THEME.BLUE

	constructor(
		public modalService: NgbModal,
		private deviceService: DeviceService,
		private translate: TranslateService,
		protected htmlDOMSanitizer: DomSanitizer,
		private ngZone: NgZone
	) { super(); }

	ngAfterViewInit(): void {
		try {
			Array.from(this.captionRef.nativeElement.querySelectorAll('a'))
				.forEach((element: any) => {
					element.setAttribute('id', 'modern-standby-link');
					element.setAttribute('class', 'modern-standby');
				});
		}
		catch (error) {

		}
	}


	ngOnInit() {
		this.childContent = {};
		this.childContent.innerHTML = '';
	}

	public onReadMoreClick($event) {
		this.readMoreClick.emit($event);
		this.contentExpand = true;
	}

	public onRightIconClick(tooltip, $event) {
		this.toggleToolTip(tooltip, true);
		this.tooltipClick.emit($event);
	}

	checkToolTips() {
		const subscription = this.scrollEvent
			.asObservable()
			.pipe(throttleTime(100))
			.subscribe((event) => {
				this.toggleToolTip(this.rightToolTip1);
				this.toggleToolTip(this.rightToolTip2);
				this.toggleToolTip(this.rightToolTip3);
			});
		this.subscriptionList.push(subscription);
	}

	public toggleToolTip(tooltip, canOpen = false) {
		if (tooltip) {
			if (tooltip.isOpen()) {
				tooltip.close();
			} else if (canOpen) {
				tooltip.open();
			}
		}
	}

	public onResetClick($event: Event) {
		this.resetClick.emit($event);
	}

	public onCustomButtonClick($event: Event) {
		this.customButtonClick.emit($event);
	}

	public onLinkClick(linkPath) {
		if (linkPath && linkPath.length > 0) {
			this.deviceService.launchUri(linkPath);
		}
	}

	public onOnOffChange($event) {
		this.toggleOnOff.emit($event);
		this.rebootConfirm($event);
	}

	public rebootConfirm($event) {
		const activeElement = document.activeElement as HTMLElement;
		if (this.title === this.translate.instant('device.deviceSettings.inputAccessories.inputAccessory.topRowFunctions.subSectionTwo.title') || this.isRebootRequired) {
			this.isSwitchChecked = !this.isSwitchChecked;
			const modalRef = this.modalService.open(ModalRebootConfirmComponent, {
				backdrop: 'static',
				size: 'sm',
				centered: true,
				windowClass: 'Reboot-Confirm-Modal'
			});

			if (this.isRebootRequired) {
				modalRef.componentInstance.description = 'device.deviceSettings.inputAccessories.fnCtrlKey.restartNote';
			} else {
				modalRef.componentInstance.description = 'device.deviceSettings.inputAccessories.inputAccessory.topRowFunctions.popup.description';
			}

			const closeBtn = document.getElementById("btnClose");
			closeBtn.focus();

			modalRef.result.then(
				result => {
					if (result === 'enable') {
						this.rebootToggleOnOff.emit($event);
					} else if (result === 'close') {
						this.isSwitchChecked = !this.isSwitchChecked;
					}
					activeElement.focus();
				},
				reason => {
				}
			);

		} else {
			this.rebootToggleOnOff.emit($event);
		}
	}



	htmlSanitizer(htmlContent) {
		return this.htmlDOMSanitizer.bypassSecurityTrustHtml(this.htmlDOMSanitizer.sanitize(SecurityContext.HTML, htmlContent));
	}


	voicePopUp() {
		const modalRef = this.modalService.open(ModalVoiceComponent,
			{
				backdrop: 'static',
				size: 'sm',
				centered: true,
				windowClass: 'Voice-Modal',
			});
		modalRef.componentInstance.value = this.voiceValue;
		modalRef.componentInstance.metricsParent = this.metricsParent;
	}

	ngOnDestroy() {
		window.removeEventListener('scroll', () => { });
		this.subscriptionList.forEach((s: Subscription) => s.unsubscribe());
	}

	removeHTMLFormatting(source: string) {
		try {
			return source.replace(/<\/?.+?\/?>/g, ' ').replace(/  +/g, ' ');
		}
		catch (error) {

			return source;
		}
	}

	uiSwitchClass(): string {
		let switchClass: string;
		if(this.isSwitchVisible && !this.resetTextAsButton) {
			switchClass='flex-grow-1 d-flex justify-content-end switch';
		} else if(!this.resetTextAsButton && !this.isSwitchVisible){
			switchClass = 'flex-grow-1 d-flex justify-content-end';
		}else if(this.resetTextAsButton && !this.isSwitchVisible){
			switchClass = 'col-md-5 d-flex justify-content-end reset-button';
		}

		return switchClass;
	}
}
